import {
  createContext,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

interface PageDocumentTitleContextValue {
  pageLabel: string | null;
  setPageLabel: (label: string | null) => void;
}

const PageDocumentTitleContext = createContext<PageDocumentTitleContextValue | null>(null);

export function PageDocumentTitleProvider({ children }: { children: ReactNode }) {
  const [pageLabel, setPageLabel] = useState<string | null>(null);
  const value = useMemo(
    () => ({
      pageLabel,
      setPageLabel,
    }),
    [pageLabel]
  );

  return (
    <PageDocumentTitleContext.Provider value={value}>{children}</PageDocumentTitleContext.Provider>
  );
}

export function usePageDocumentTitleContext(): PageDocumentTitleContextValue | null {
  return useContext(PageDocumentTitleContext);
}

/** Override the route default tab title with an entity name (e.g. session title). */
export function usePageDocumentTitle(label: string | null | undefined) {
  const ctx = usePageDocumentTitleContext();

  useLayoutEffect(() => {
    if (!ctx) return;
    const trimmed = label?.trim();
    ctx.setPageLabel(trimmed || null);
    return () => {
      ctx.setPageLabel(null);
    };
  }, [label, ctx]);
}
